<div class="extend">
  <app-success-message [message]="successMessage"></app-success-message>
  <app-error-message [message]="errorMessage"></app-error-message>

  <div class="user-profile">
    <app-avatar [image]="userInfo.avatarImage"></app-avatar>
    <div>
      <div class="name">{{ userInfo.name || userInfo.username }}</div>
      <button mat-raised-button appThemedButton routerLink="/user/select-avatar">
        Change Avatar
      </button>
    </div>
  </div>

  <form [formGroup]="editProfileForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label class="display-form">
        <span class="label-form">Name</span>
        <div class="input-form">
          <input
            type="text"
            class="form-control"
            formControlName="name"
            placeholder="edit name"
            required
          />
          @if (nameError) {
            <i class="material-icons error-icon">error</i>
          }
          @if (nameError) {
            <div class="note error">{{ nameError }}</div>
          }
        </div>
      </label>
    </div>

    <div class="form-bottom">
      <button mat-raised-button appThemedButton type="submit" [disabled]="isLoading">
        Save changes
      </button>
    </div>
  </form>
</div>
